import { useMemo } from "react";

import { ColocaForm } from "@/shared/components/forms/ColocaForm";
import { ColocaInputField } from "@/shared/components/forms/ColocaInputField";
import { useZodForm } from "@/shared/components/forms/useZodForm";
import useTranslations from "@/shared/lang/useTranslations";

import { mexicoPayerSchema, type MexicoPayerValues } from "./depositPayer.schema";
import type { DepositPayerStepProps } from "./RailDepositDrawer";

const rfcInput = (raw: string) => raw.toUpperCase().replace(/\s/g, "").slice(0, 13);

/** The payer of a SPEI collection: the name is required, the RFC optional. */
export function MexicoPayerStep({
  formId,
  defaults,
  amount,
  onSubmit,
}: DepositPayerStepProps<MexicoPayerValues>) {
  const { t } = useTranslations("wallets");
  const schema = useMemo(
    () => mexicoPayerSchema({ name: t("deposit_payer_name_error"), rfc: t("deposit_payer_rfc_error") }),
    [t],
  );
  const form = useZodForm(schema, defaults);

  return (
    <ColocaForm id={formId} form={form} onSubmit={onSubmit} className="space-y-5">
      {amount}
      <div className="space-y-4">
        <ColocaInputField
          name="payerName"
          label={t("deposit_payer_name_label")}
          placeholder={t("deposit_payer_name_placeholder")}
          maxLength={120}
          autoComplete="name"
          required
        />
        <ColocaInputField
          name="rfc"
          label={t("deposit_payer_rfc_label")}
          placeholder={t("deposit_payer_rfc_placeholder")}
          description={t("deposit_spei_hint")}
          maxLength={13}
          autoComplete="off"
          transform={rfcInput}
        />
      </div>
    </ColocaForm>
  );
}
